import { Control, FieldValues, useController } from "react-hook-form";
import clsx from "clsx";

import { IOption } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  name?: string;
  options: Array<IOption>;
  defaultOption?: IOption;
  changeCallback?: (value: IOption) => void;
  control?: Control<FieldValues>;
}

export default function ContentSwitch({
  name,
  options,
  defaultOption,
  changeCallback,
  control
}: Readonly<IProps>) {
  const {
    field: { value, onChange }
  } = useController({
    name: name ?? "",
    control: control,
    defaultValue: defaultOption ?? options[0]
  });

  const handleChange = (option: IOption) => {
    onChange(option);
    if (changeCallback) changeCallback(option);
  };

  return (
    <div className={styles.smartContentSwitch}>
      {options.map((item) => (
        <button
          type="button"
          key={item.id}
          onClick={() => handleChange(item)}
          className={clsx(
            "flex-1 p-4 leading-4",
            item.id === value.id
              ? "bg-gradient-to-r from-primary to-secondary"
              : "bg-background text-primary"
          )}>
          {item.label}
        </button>
      ))}
    </div>
  );
}
